import React, { Suspense } from "react";
import { lazyComReload } from "utils/lazyComReload";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { TERMOS_PREFIX_PATH } from "configs/AppConfig";

export const TermosViews = () => {
	return (
		<Suspense fallback={<Loading cover="page" />}>
			<Switch>
				<Route
					path={`${TERMOS_PREFIX_PATH}`}
					component={lazyComReload(() => import("./conteudo"))}
				/>
				<Redirect
					from={TERMOS_PREFIX_PATH}
					to={`${TERMOS_PREFIX_PATH}`}
				/>
			</Switch>
		</Suspense>
	);
};

export default TermosViews;
